import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import './css/ClientLogos.css';
import barrick from './img/barrick_logo.png';
import i80 from './img/i80_logo.png';
import mosaic from './img/mosaic_logo.png';
import sibanye from './img/sibanye_logo.png';

function ClientLogos() {
  return (
    <section className="client-strip">
      <Container>
        <p className="client-strip-label">Trusted by mining operators</p>
        <div className="client-strip-logos">
          <img className="client-logo-img" src={barrick} alt="Barrick" />
          <img className="client-logo-img" src={i80} alt="I80 Gold" />
          <img className="client-logo-img" src={mosaic} alt="Mosaic" />
          <img className="client-logo-img" src={sibanye} alt="Sibany-Stillwater" />
        </div>
      </Container>
    </section>
  );
}

export default ClientLogos;
